<template>
    <div class="consultTeacher">
        <div v-show="showType == 1" class="consultTeacherMain">
            <div class="header">
                <span>在线老师列表</span>
            </div>
            <div class="TeacherList">
                <div v-for="(item,index) in teacherList" class="teacherCell" :key="index" @click="toDetail(item)">
                    <img :src="item.header">
                    <span class="nameSpan">{{item.wx_nick_name}}</span>
                    <span class="unRead" v-if="item.unRead > 0">{{item.unRead}}</span>
                </div>
            </div>
            <img class="closeBtn" @click="closeBtnClicked" src="https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png">
        </div>
        <div class="messageMain" v-show="showType == 2">
            <div class="header">
                <img @click="backList" class="back" src="https://tengfaceliveuser.tengface.net/web/wx-user/img/jiantou_back.png" />
                <span @click="backList">返回列表</span>
            </div>
            <div id="messageBox" class="messageBox">
              <div v-for="(item,index) in messageList" class="messageCell" :key="index">
                  <div>
                    <div class="messageHeader other">
                      <img :src="item.header" />
                      <span class="name">{{item.nick}}</span>
                      <span class="time">{{item.create_time}}</span>
                    </div>
                  </div>
                  <div class="content" v-dompurify-html="item.content"></div>
                  <div v-if="item.pic_url" class="contentImg">
                    <img :src="item.pic_url" @click="preview(item.pic_url)">
                  </div>
              </div>
            </div>
            <div class="inputBox">
                <van-field
                    class="inputField"
                    style=""
                    v-model="comment"
                    @keyup.enter="sendC2CMsg"
                    placeholder="说点什么..."
                />
                <van-button
                    class="sendBtn"
                    type="primary"
                    @touchstart="sendC2CMsg"
                    style="margin-right: 10px;"
                    size="small"
                    >发送</van-button
                >
            </div>
            <img class="closeBtn" @click="closeBtnClicked" src="https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png">
        </div>
    </div>
</template>

<script>

import tool from '../../../../kits/Tools';
import qs from 'qs';
import handleim from '../../../../kits/im/handleim';


export default {
    props: {
        dsId: {
            type: Number | String,
            default: 0
        },
        fansId: {
            type: Number | String,
            default: 0
        },
        tid: {
            type: Number | String,
            default: 0
        }
    },
    data(){
        return{
            teacherList:[],
            timer:null,
            showType: 1,
            selectItem: null,
            messageList: [],
            comment:''
        }
    },
    watch:{
        // dsId (to) {
        //     if (to) {
                
        //         this.startTimeList()
        //     }
        // },
        showType (to) {
           this.switchTimeList();
        },
         
    },
    methods:{
        preview(url) {
            wx.previewImage({
            current: url, // 当前显示图片的http链接
            urls: [url], // 需要预览的图片http链接列表
            });
        },
        switchTimeList(){
            if (this.showType === 1) {
                this.startTimeList()
            }else {
                this.stopTimeList();
            }
        },
        stopTimeList(){
            clearInterval(this.timer);
            this.timer = null;
        },
        closeBtnClicked(){
            this.stopTimeList();
            this.$emit("closeBtnClicked");
        },
        sendC2CMsg () {
            if (this.selectItem) {
                if(this.comment === ""){
                    return
                }
                const param = {
                ds_id: this.dsId,
                to: this.selectItem.fans_id,
                fans_id: this.fansId,
                content: this.comment,
                terminal_type: 1
                }
                if (this.tid) {
                param.tid = this.tid
                }
                let self = this
                this.axios
                .post(tool.baseUrl2() + '/comment/index/addC2C',
                    qs.stringify(param)
                )
                .then(function (data) {
                    self.comment = "";
                    self.messageList.push(data.data.data.content)
                    setTimeout(() => {
                    let chatContent = document.getElementById('messageBox')
                    chatContent.scrollTop = chatContent.scrollHeight
                    }, 50)
                    handleim.onSendP2PMsg(JSON.stringify(data.data.data.content), self.selectItem.fans_id)
                })
                .catch(function (data) { console.log(data); })
            }
        },
        getTeacherList () {
            const param = {
                ds_id: this.dsId
            }
            if (this.tid) {
                param.tid = this.tid
            }
            let self = this
            this.axios.post(tool.baseUrlUser() + '/app/index/getOnlineTeacherList',
                qs.stringify(param)
                )
                .then(function (data) {
                if (data.data.code === 2000) {
                    const tList = [];
                    data.data.data.list.forEach(element => {
                    const item = self.teacherList.find((item)=>{ return item.fans_id == element.fans_id})
                        element.unRead = item && item.unRead ? item.unRead : 0;
                        tList.push(element);
                    });
                    self.teacherList = tList;
                }
                })
                .catch(function (data) {})
        },
        toDetail (item) {
            this.selectItem = item
            this.showType = 2
            item.unRead = 0;
            this.getMessageList()
        },
        startTimeList () {
            this.getTeacherList();
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
            this.timer = setInterval(() => {
                this.getTeacherList()
            }, 10000)
        },
        getMessageList () {
            const param = {
                ds_id: this.dsId,
                fans_id: this.fansId,
                to: this.selectItem.fans_id
            }
            if (this.tid) {
                param.tid = this.tid
            }
            let self = this
            this.axios
                .post(tool.baseUrl2() + '/comment/index/getC2CHistory',
                qs.stringify(param)
                )
                .then(function (data) {
                if (data.data.code === 200) {
                    self.messageList = data.data.data
                    setTimeout(() => {
                        let chatContent = document.getElementById('messageBox')
                        chatContent.scrollTop = chatContent.scrollHeight
                    }, 50)
                }
                })
                .catch(function (data) {})
        },
        backList(){
            this.showType = 1
            this.selectItem = null;
        },
        receivedMsg(json){
            if(this.showType == 1){
                this.teacherList.forEach((item)=>{
                    if(item.fans_id == json.fans_id){
                        item.unRead = item.unRead + 1;
                    }
                })
                return;
            }

            if(this.showType == 2 && this.selectItem && json.fans_id == this.selectItem.fans_id){
                this.messageList.push(json);
                setTimeout(() => {
                    let chatContent = document.getElementById('messageBox')
                    chatContent.scrollTop = chatContent.scrollHeight
                }, 50)
            }
        }
    }
    
}
</script>

<style scoped>

.consultTeacher{
    width: 100%;
    height: 355px;
    position:fixed;
    bottom: 0px;
    left: 0px;
    z-index: 5000;
}

.consultTeacher .consultTeacherMain{
    position:relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    width: 100%;
    height: 100%;
    background-color: white;
}

.consultTeacher .messageMain{
    position:relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    width: 100%;
    height: 100%;
    background-color: white;
}

.messageMain .header{
    height: 40px;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.messageMain .header .back{
    width: 20px;
    margin-left: 15px;
    vertical-align: -5px;
}

.messageMain .header span{
    line-height: 40px;
}

.consultTeacherMain .header{
    height: 40px;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.consultTeacherMain .header span{
    line-height: 40px;
    margin-left: 20px;
}

.closeBtn{
    width: 20px;
    height: 20px;
    position:absolute;
    right: 10px;
    top: 10px;
}

.consultTeacher .consultTeacherMain .TeacherList{
    width: 100%;
    height: 259px;
    overflow: auto;
}

.consultTeacherMain .TeacherList .teacherCell{
    height: 50px;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    position: relative;
}

.consultTeacherMain .TeacherList .teacherCell .nameSpan{
    line-height: 50px;
    margin-left: 10px;
}

.consultTeacherMain .TeacherList .teacherCell .unRead{
    color: aliceblue;
    display: inline-block;
    position: absolute;
    top: 12px;
    right: 24px;
    padding: 5px;
    text-align: center;
    background-color: red;
    border-radius: 10px;
    font-size: 12px;
}

.consultTeacherMain .TeacherList .teacherCell img{
    margin-left: 20px;
    height: 40px;
    width: 40px;
    border-radius: 20px;
}

.messageBox{
  overflow-x: hidden;
  height: 219px;
}

.messageCell{
  margin-top: 5px;
  margin-bottom: 5px;
}

.messageCell .messageHeader{
  height: 40px;
  position:relative;
}

.messageHeader .time{
  font-size: 12px;
  position: absolute;
  top: 8px;
  right: 20px;
}

.messageHeader .name{
  font-size: 14px;
  position: absolute;
  top: 2px;
  left: 42px;
}

.messageCell .messageHeader img{
  height: 30px;
  position: absolute;
  width: 30px;
  border-radius: 15px;
}

.messageCell .other{
  top: 5px;
  left: 10px;
}


.messageCell .content{
  padding-left: 48px;
  word-wrap:break-word;
  word-break:normal;
  padding-right: 20px;
  white-space: pre-line;
}

.inputBox{
    width: 100%;
    height: 40px;
}

.inputBox .inputField{
    float: left;
    background-color: #FFFFFF;
    padding-bottom: 5px;
    padding-top: 5px;
    padding-left: 5px;
    margin-left: 10px;
    margin-right: 10px;
    border: solid 1px #F5F5F5; 
    border-radius: 10px;
    width: 70%;
    margin-top: 2px;
}
.inputBox .sendBtn{
    float: left;
    width: 20%;
    margin-top: 5px;
}

.contentImg{
    max-width: 45%;
    padding: 10px;
    padding-left: 48px;
}

</style>